import { useMemo } from "react";

export function useCurrencyFormatter() {
  const isoCode = "USD";

  const currencyFormatter = useMemo(
    () =>
      new Intl.NumberFormat(undefined, {
        style: "currency",
        currencyDisplay: "narrowSymbol",
        currency: isoCode,
      }),
    [isoCode]
  );

  return currencyFormatter;
}

export function useToCentsFormatter() {
  const isoCode = "USD";

  const currencyFormatter = useMemo(
    () =>
      new Intl.NumberFormat(undefined, {
        style: "currency",
        currencyDisplay: "narrowSymbol",
        currency: isoCode,
      }),
    [isoCode]
  );

  const exponent =
    currencyFormatter.resolvedOptions().maximumFractionDigits ?? 2;

  return function formatToCents(amount: number) {
    const factor = Math.pow(10, exponent);
    return Math.round(amount * factor);
  };
}

export function usePercentFormatter(
  options: Omit<Intl.NumberFormatOptions, "style"> = {}
) {
  const percentFormatter = useMemo(
    () =>
      new Intl.NumberFormat(undefined, {
        ...options,
        style: "percent",
      }),
    [options]
  );

  return percentFormatter;
}
